import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import prototype from './utils/prototype'

import MetaInfo from 'vue-meta'
import xss from 'xss'
// 引入公共JS
import '@/assets/iconfont/iconfont.css'
import '../static/css/ckeditor.css'
import '../static/css/index.css'
// import '@/static/cdn/vue'
// import '@/static/cdn/element-ui.css'
// import '@/static/cdn/element-ui'

import App from './App'
import router from './router'
import store from './store'

import './permission' // permission control
Vue.config.productionTip = false
Vue.use(prototype)
Vue.use(MetaInfo)
// 定义全局XSS解决方法
Object.defineProperty(Vue.prototype, '$xss', {
  value: xss
})

// 引入全局工具类

Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})

/* eslint-disable no-new */
new Vue({
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
  el: '#app',
  router,
  //需要将store和vue实例进行关联，这里将其传递进去
  store,
  components: {App},
  template: '<App/>',

})



// WEBPACK FOOTER //
// ./src/main.js